import React from 'react';
import { useTranslation } from "react-i18next";
const UserNotAuthorised = () => {
    const { t } = useTranslation();
    return (
            <div className='main-title'>
                <div className="textstart">
                    <div className='heading p-5'>{t("kclGloves.Admin_Not_Authorized")}</div>
                </div>
            </div>
    );
};
export default UserNotAuthorised;